@use '@design/design-tokens/typography/typography' as *;

.tooltipWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 200px;
}

.rightWrapper {
  display: flex;
  flex-direction: column;
}

.titleLabel {
  @include typography-v2-title-sm;
}

.categoryLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}
